export default {"src":"/_next/static/media/gsk.e6de1f27.svg","height":93,"width":102,"blurWidth":0,"blurHeight":0};